<script setup lang="ts">
import { ref, type PropType, onMounted, onUnmounted } from 'vue'

export interface QuoteBoxItem {
	text: string
	name: string
}

defineProps({
	item: {
		type: Object as PropType<QuoteBoxItem>,
		required: true,
	},
})

const isActive = ref(false)
const quoteBoxRef = ref<HTMLElement | null>(null)

let observer: MutationObserver | null = null
onMounted(() => {
	observer = new MutationObserver(mutations => {
		for (const mutation of mutations) {
			if (
				mutation.type === 'attributes' &&
				mutation.attributeName === 'class'
			) {
				isActive.value =
					quoteBoxRef.value?.classList.contains('active') ?? false
			}
		}
	})

	if (quoteBoxRef.value) {
		observer.observe(quoteBoxRef.value, { attributes: true })
	}
})

onUnmounted(() => {
	observer?.disconnect()
})
</script>

<template>
	<div
		ref="quoteBoxRef"
		data-quote-box
		class="swiper-slide min-w-full rounded-rwd-xl border border-white px-20px pb-20px pt-24px text-white mdp:min-w-[432px] mdp:max-w-[432px]"
	>
		<div
			class="flex h-full flex-col items-center justify-center overflow-hidden"
		>
			<i
				class="bs-new-icon icon-quote mb-16px h-[27px] w-[36px] shrink-0 self-start text-b-50%"
				:class="{
					active: isActive,
					'': !isActive,
				}"
			></i>
			<div
				class="typography-s1-emp text-n950 line-clamp-5 overflow-hidden text-ellipsis"
			>
				{{ item.text }}
			</div>

			<div
				class="box-bottom mt-auto flex flex-col items-center justify-center gap-16px text-b-50%"
			>
				<i
					class="bs-new-icon icon-quoteUnderline h-[14px] w-[800px]"
					:class="{
						active: isActive,
						'': !isActive,
					}"
				></i>

				<div
					class="typography-s1-emp"
					:class="{
						'text-o-500': isActive,
					}"
				>
					{{ item.name }}
				</div>
			</div>
		</div>
	</div>
</template>
